// extracted by mini-css-extract-plugin
export default {"deleteText":"EnableMFAPassword_deleteText__kBbxw"};